import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-brand-dark text-white pt-16 pb-8" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-94">
          <div className="col-span-1 md:col-span-1" data-id="element-95">
            <img className="h-24 w-auto mb-6" src="https://cdn.magicpatterns.com/uploads/jbELFVU6yimTHPdBB4r5GJ/175975597_padded_logo.png" alt="Precision Pro Sprayers" data-id="element-96" />
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-97">
              Professional grade electric sprayers built for contractors who
              need reliability and speed.
            </p>
          </div>

          <div data-id="element-98">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-99">
              Products
            </h3>
            <ul className="space-y-3" data-id="element-100">
              <li data-id="element-101">
                <Link to="/products/forcex-complete" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-102">
                  ForceX Complete Kit
                </Link>
              </li>
              <li data-id="element-103">
                <Link to="/products/forcex-diy" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-104">
                  ForceX DIY Kit
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-105">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-106">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-107">
              <li data-id="element-108">
                <Link to="/about" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-109">
                  About Us
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/warranty" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-111">
                  Warranty & Returns
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/contact" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-113">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-114">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-115">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-116">
              <li className="flex items-start" data-id="element-117">
                <Phone className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-118" />
                <span className="text-gray-300" data-id="element-119">810-818-5941</span>
              </li>
              <li className="flex items-start" data-id="element-120">
                <Mail className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-121" />
                <span className="text-gray-300" data-id="element-122">
                  brandon@precisionprosprayers.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-123">
          <p className="text-gray-500 text-sm" data-id="element-124">
            © {new Date().getFullYear()} Precision Pro Sprayers. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-125">
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-126">
              Privacy Policy
            </Link>
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-127">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}